export default "__VITE_ASSET__BakCPfuH__"